import { isBlankTranscript } from '../captures/capture-status';

/**
 * Merging spoken words into text somebody may already have typed.
 *
 * **AN EXISTING CREWLINK CONVENTION, MOVED RATHER THAN INVENTED.** This function
 * lived privately inside `CaptureCreateScreen.tsx` and settled the question
 * there first: the common case is an empty field, where the transcript simply
 * becomes the text — but if he typed first and then spoke, **silently
 * overwriting the typed half would lose work he can see on the screen.** The
 * transcript is appended on its own line instead.
 *
 * **NOTHING IS EVER DISCARDED WITHOUT HIM DOING THE DISCARDING.**
 *
 * It moved here so Ask Sol's microphone behaves identically to Capture's without
 * a second copy of the rule. A second copy is how two screens start disagreeing
 * about what happens to a half-typed sentence — the same class of drift that put
 * an un-tappable list on a phone.
 *
 * **THE BLANK TEST IS THE ONE CREWLINK ALREADY HAD**, imported rather than
 * restated. It mirrors the whitespace set the server treats as empty (migration
 * 0005, finding F4), and a second hand-written copy of that character class is
 * precisely the kind of duplication worth refusing.
 */
export function deliverTranscript(existing: string, transcript: string): string {
  if (isBlankTranscript(existing)) return transcript;
  return `${existing}\n${transcript}`;
}
